/**
 * Query keys centralizzate per le query TanStack Query relative alle temperature.
 * Usa questa struttura per garantire invalidazione consistente della cache.
 */
export const temperatureQueryKeys = {
  all: ['temperature'] as const,
  records: (date: string) => ['temperature', 'records', date] as const,
  calendar: (from: string, to: string) => ['temperature', 'calendar', from, to] as const,
  equipmentList: () => ['temperature', 'equipment-list'] as const,
  equipmentHistory: (equipmentId: string, from: string | null, to: string | null) =>
    ['temperature', 'equipment-history', equipmentId, from, to] as const,
};
